import { createGtm } from '@gtm-support/vue-gtm'

export default function setupGTM(app, router) {
  const gtmId = process.env.VUE_APP_GTM_ID || 'GTM-PKNMXR65'
  
  app.use(createGtm({
    id: gtmId,
    router: router,
    debug: process.env.NODE_ENV === 'development', // Enable debug mode in development
    vueRouter: router,
    ignoredViews: [], // Add any views you want to ignore
    trackOnNextTick: false, // Track immediately
    defer: false, // Load GTM immediately
    compatibility: false,
    nonce: '2726c7f26c', // Add a nonce if needed for CSP
    enabled: true, // Enable tracking
    loadScript: true // Automatically load GTM script
  }))
}
